import useSwr from "@/core/composables/swr/useSwr";
import {alertApi} from "@/container";
import {computed, onMounted, ref} from "vue";
import {cacheKey} from "@/lib/cache";

/**
 * Composable to fetch alerts.
 */
const useAlerts = () => {
    const version = ref<null | string | undefined>(undefined);

    onMounted(async () => {
        if(window.ipcRenderer) {
            version.value = await window.ipcRenderer.invoke("electron-version");
        } else {
            version.value = null;
        }
    });

    const key = computed(() => {
        if (version.value === undefined) {
            return null;
        }

        return cacheKey("alerts", {version: version.value});
    });

    const {data, isLoading} = useSwr(
        () => key.value,
        () => alertApi().index({version: version.value})
    );

    return {
        data,
        isLoading
    };
};

export default useAlerts;
